/**
 * Delefant Theme - Main JavaScript
 *
 * @package Delefant
 * @author Thinking Mark
 * @since 1.0.0
 */

import './modules/contactForm7';
import './modules/ModalWP';
import './modules/modalContactForm7';
import './modules/social_share_buttons';

document.addEventListener('DOMContentLoaded', () => {
  // console.log('🚀 DOM Ready y Olé');


});

// Exportar funciones si necesitamos usarlas desde otros módulos
// export const init = () => {
//   console.log('Init function called');
// };
